import Vue from 'vue';
import Api from '@/providers/Api';
import { createGeographyQuestionObjectFromJobProfile } from '@/helpers/jobQuestionsHelper';

export const SET_JOB_PROFILES_MUTATION = 'SET_JOB_PROFILES_MUTATION';
export const ADD_JOB_PROFILE_MUTATION = 'ADD_JOB_PROFILE_MUTATION';
export const UPDATE_JOB_PROFILE_MUTATION = 'UPDATE_JOB_PROFILE_MUTATION';
export const DELETE_JOB_PROFILE_MUTATION = 'DELETE_JOB_PROFILE_MUTATION';
export const CLEAR_JOB_PROFILES_MUTATION = 'CLEAR_JOB_PROFILES_MUTATION';
export const GET_JOB_PROFILES_ACTION = 'GET_JOB_PROFILES_ACTION';
export const CREATE_JOB_PROFILE_ACTION = 'CREATE_JOB_PROFILE_ACTION';
export const UPDATE_JOB_PROFILE_ACTION = 'UPDATE_JOB_PROFILE_ACTION';
export const DELETE_JOB_PROFILE_ACTION = 'DELETE_JOB_PROFILE_ACTION';
export const COPY_JOB_PROFILE_ACTION = 'COPY_JOB_PROFILE_ACTION';

export default {
  state: {
    items: [],
  },
  mutations: {
    [SET_JOB_PROFILES_MUTATION]: function (state, payload) {
      state.items = payload;
    },
    [ADD_JOB_PROFILE_MUTATION]: function (state, payload) {
      state.items.push(payload);
    },
    [UPDATE_JOB_PROFILE_MUTATION]: function (state, payload) {
      const currIndex = state.items.findIndex((item) => item.id === payload.id);
      if (currIndex > -1) {
        Vue.set(state.items, currIndex, payload);
      }
    },
    [DELETE_JOB_PROFILE_MUTATION]: function (state, payload) {
      const currIndex = state.items.findIndex((item) => item.id === payload.id);
      state.items.splice(currIndex, 1);
    },
    [CLEAR_JOB_PROFILES_MUTATION]: function (state) {
      state.items = [];
    },
  },
  actions: {
    [GET_JOB_PROFILES_ACTION]: async function ({ commit }) {
      const profiles = await Api.getUserJobProfiles();
      profiles.forEach((profile) => {
        if (Array.isArray(profile.jobQuestions)) {
          profile.jobQuestions.push(
            createGeographyQuestionObjectFromJobProfile(profile)
          );
        }
      });
      commit(SET_JOB_PROFILES_MUTATION, profiles);
    },
    [CREATE_JOB_PROFILE_ACTION]: async function ({ commit }, newProfileData) {
      const newProfile = await Api.createUserJobProfile(newProfileData);
      commit(ADD_JOB_PROFILE_MUTATION, newProfile);
      return newProfile;
    },
    [COPY_JOB_PROFILE_ACTION]: async function ({ commit }, newProfileData) {
      const newProfile = await Api.copyProfile(newProfileData);
      commit(ADD_JOB_PROFILE_MUTATION, newProfile);
      return newProfile;
    },
    [UPDATE_JOB_PROFILE_ACTION]: async function (
      { commit },
      updatedProfileData
    ) {
      const updatedProfile = await Api.updateUserJobProfile(updatedProfileData);
      commit(UPDATE_JOB_PROFILE_MUTATION, updatedProfile);
      return updatedProfile;
    },
    [DELETE_JOB_PROFILE_ACTION]: async function ({ commit }, id) {
      await Api.deleteUserJobProfile(id);
      commit(DELETE_JOB_PROFILE_MUTATION, id);
    },
  },
};
